export const UserAccountType = {
  APP: 'app',
  ATLASSIAN: 'atlassian',
  CUSTOMER: 'customer'
};